import _ from 'lodash';
import React, { useEffect} from 'react';
import Dialog from '@material-ui/core/Dialog';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import useForm from '@jumbo/utils/useForm';
import { IniciarPresupuestoCobrosNeto,SolicitarEjecucion} from '../../redux/actions/Ejecucion';
import { Typography } from '@material-ui/core';
import { Divider } from '@material-ui/core';
import {ValorSelect} from './utils/Helper';
import Autocompetesinapp from './utils/Autocompetesinapp';
import Pickersinapp from './utils/Pickersinapp';
import useStyles from '@jumbo/components/ListadoEjecucion/EjecucionStyle';
import {NumberFormatEnteroPositivo} from './utils/NumberFormatCustom';

const PresupuestoCobrosNeto = ({ open, onCloseDialog,formApp }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const { usuarioID } = useSelector(({ auth }) => auth.authUser);
     const { hotel,hotelgroup,touroperator,touroperatorgroup,market,paymentcondition,cartera,frecuency,invoicecondition,tiporeporte} = useSelector(({ ejecucion }) => ejecucion);
    const { form, setForm } = useForm({
        "generationdate":null,
        "hotel": null,
        "hotelgroup": null,
        "touroperator": null,
        "touroperatorgroup": null,
        "paymentcondition": null,
        "market": null,
        "cartera": null,
        "countbudgetmonth": null,
        "frecuencia":'',
        "invoicecondition":'',
        "tiporeporte": null
    });

     useEffect(() => {
        dispatch(IniciarPresupuestoCobrosNeto(formApp.formAppID));
     }, [dispatch,formApp ]);



    const ejecucion = () => {
     
        let variables = "";
        
      if(form.generationdate){variables += `${form.generationdate}`
      }else{variables += "null"}

      if(form.hotel){variables += `|${form.hotel}`
      }else{variables += "|null"}

      if(form.hotelgroup){variables += `|${form.hotelgroup}`
      }else{variables += "|null"}

      if(form.touroperator){variables += `|${form.touroperator}`
      }else{variables += "|null"}

      if(form.touroperatorgroup){variables += `|${form.touroperatorgroup}`
      }else{variables += "|null"}

      if(form.paymentcondition){variables += `|${form.paymentcondition}`
      }else{variables += "|null"}

      if(form.market){variables += `|${form.market}`
      }else{variables += "|null"}

      if(form.cartera){variables += `|${form.cartera}`
      }else{variables += "|null"}

      if(form.countbudgetmonth){variables += `|${form.countbudgetmonth}`
      }else{variables += "|null"}

      if(form.frecuencia){variables += `|${form.frecuencia}`
      }else{variables += "|null"}
      
      if(form.invoicecondition){variables += `|${form.invoicecondition}`
      }else{variables += "|null"}

        let Solicitar = {
          "FormAppID":formApp.formAppID,
          "UsuarioID":usuarioID,
          "OrdenarPorID":form.tiporeporte,
          "Computador":"192.163", 
          "UserNameComputador":"192.163", 
          "ValorVersion":null, 
          "CriteriosEjecucion":variables, 
          "CriteriosEjecucionExclusion":"" 
        }
          
         dispatch(SolicitarEjecucion(Solicitar))
      };

    return (
        <Dialog open={open}  className={classes.dialogRoot} fullWidth maxWidth="md" >
             <DialogTitle className={classes.dialogTitleRoot}>{formApp.titulo} </DialogTitle>
             <DialogContent dividers>
            <div className={classes.root}>  
         
             <Typography variant='h4'>Criterios de Búsqueda</Typography>
              <Divider classes={{root: classes.divider}}/>

              <Pickersinapp
                          label="Generarion Date"
                          value={form.generationdate}
                          onChange={(date) =>{date !== null ? setForm(_.set({ ...form }, 'generationdate', `${date.format('YYYYMMDD')}`)) : setForm(_.set({ ...form }, 'generationdate', null))}}
                          style={{paddingRight:10,width:350}}
                 />

                <Autocompetesinapp 
                    multiple 
                    disableCloseOnSelect 
                    options={hotel} 
                    name="Hotel"
                    onChange={(event, newValue) => {
                       setForm(_.set({ ...form }, 'hotel', ValorSelect(newValue))) 
                    }}
                />

                <Autocompetesinapp 
                  options={hotelgroup} 
                  name="Hotel Group"
                  onChange={(event, newValue) => {
                    setForm(_.set({ ...form }, 'hotelgroup', ValorSelect(newValue))) 
                  }}
                />

                <Autocompetesinapp 
                    multiple 
                    disableCloseOnSelect 
                    options={touroperator} 
                    name="Tour Operator"
                    onChange={(event, newValue) => {
                      setForm(_.set({ ...form }, 'touroperator', ValorSelect(newValue))) 
                    }}
                />

               <Autocompetesinapp 
                  options={touroperatorgroup} 
                  name="Tour Operator Group"
                  onChange={(event, newValue) => {
                    setForm(_.set({ ...form }, 'touroperatorgroup', ValorSelect(newValue))) 
                  }}
                />

            <Autocompetesinapp 
                   multiple 
                  disableCloseOnSelect 
                  options={market} 
                  name="Market"
                  onChange={(event, newValue) => {
                    setForm(_.set({ ...form }, 'market', ValorSelect(newValue))) 
                  }}
                />

              <Autocompetesinapp 
                    options={paymentcondition} 
                    name="Payment Condition"
                    onChange={(event, newValue) => {
                      setForm(_.set({ ...form }, 'paymentcondition', ValorSelect(newValue))) 
                    }}
                />

                <Autocompetesinapp 
                    options={cartera} 
                    name="Cartera"
                    onChange={(event, newValue) => {
                      setForm(_.set({ ...form }, 'cartera', ValorSelect(newValue))) 
                    }}
                />
                <div>
                  <TextField 
                    className={classes.textlabel}
                     size='small'
                     label="Count Budget Month" 
                     variant="outlined"
                     value={form.countbudgetmonth}
                     onChange={(value) => setForm(_.set({ ...form }, 'countbudgetmonth', value.target.value)) } 
                     style={{width:350}}
                     InputProps={{
                      inputComponent: NumberFormatEnteroPositivo,
                     }}
                     />
                </div>
              
               <Autocompetesinapp 
                    options={frecuency} 
                    name="Frecuency"
                    onChange={(event, newValue) => {
                      setForm(_.set({ ...form }, 'frecuencia', ValorSelect(newValue))) 
                    }}
                />

              <Autocompetesinapp 
                    options={invoicecondition} 
                    name="Invoice Condition"
                    onChange={(event, newValue) => {
                      setForm(_.set({ ...form }, 'invoicecondition', ValorSelect(newValue))) 
                    }}
                />


              <Typography variant='h4'>Tipo de Reporte</Typography>
              <Divider classes={{root: classes.divider}}/>

              <Autocompetesinapp 
                    options={tiporeporte} 
                    name="Tipo de Reporte"
                    onChange={(event, newValue) => {
                      setForm(_.set({ ...form }, 'tiporeporte', ValorSelect(newValue))) 
                    }}
                />

           
              </div>
        
              <Box display="flex" justifyContent="flex-end" my={4}>
                <Button className={classes.button} variant="contained" onClick={onCloseDialog}>Cancelar</Button>
                   <Box ml={2}>
                    <Button className={classes.button}  variant="contained" color="secondary" onClick={() => ejecucion()}>
                       Ejecutar
                    </Button>
                </Box>
             </Box>
            </DialogContent>  
        </Dialog>
    )
};

export default PresupuestoCobrosNeto;

PresupuestoCobrosNeto.prototype = {
  open: PropTypes.bool.isRequired,
  onCloseDialog: PropTypes.func,
};
